import { useEffect } from 'react';
import { useSetTeamsConfigActions } from '../../store/main';
export const useSetTeamsNavigationConfig = config => {
  const {
    setNavigationConfig
  } = useSetTeamsConfigActions();
  useEffect(() => {
    setNavigationConfig(config);
  }, [setNavigationConfig, config]);
};